export enum MenuTypeCode {
  Parliamentary = 'PRLMNU',
  Municipality = 'MUNCPMNU',
}

export enum LookupsParents {
  Years = 'YEAR',
}

export const SettingsCodes = {
  DECSECT: 'DECSECT',
  ELECTSECT: 'ELECTSECT',
  RLTLINKS: 'RLTLINKS',
  FBLINK: 'FBLINK',
  YOUTBE: 'YOUTBE',
  TWTER: 'TWTER',
  INSTA: 'INSTA',
  HOMEBNR: 'HOMEBNR',
  EMAIL: 'EMAIL',
  MAILCODE: 'MAILCODE',
  ADDRESS: 'ADDRESS',
  PHONE: 'PHONE',
  CRNTTYPE: 'CRNTTYPE',
} as const;

export enum LanguageId {
  English = 1,
  Arabic = 2,
}
